import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { MatDialog } from '@angular/material/dialog';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableOption } from '../../components/kiene-table/table-option';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { EntsorgerDetailsDialogComponent } from './entsorger-details-dialog/entsorger-details-dialog.component';
import { Entsorger } from '../../../../projects/kiene-core/src/lib/components/stammdaten/entsorger/entsorger';

@Component({
    selector: 'kiene-entsorger',
    templateUrl: './entsorger.component.html',
    styleUrls: ['./entsorger.component.scss'],
})
export class EntsorgerComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private tableService: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.headline = 'Entsorger';
        this.tableDescriptor.uniqueIdentifier = 'Entsorger';
        this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'entsorger/read_kundenportal.php';
        this.tableDescriptor.route = '/stammdaten/entsorger/';
        this.tableDescriptor.nameOfIdField = 'entsorger_id';
        this.tableDescriptor.searchPlaceholder = 'Entsorger durchsuchen';

        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openEditDialog.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('entsorger_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('name', 'Name'));
        this.tableDescriptor.columns.push(new TableColumn('vvvo', 'VVVO'));
        this.tableDescriptor.columns.push(new TableColumn('strasse', 'Strasse'));
        this.tableDescriptor.columns.push(new TableColumn('plz', 'PLZ'));
        this.tableDescriptor.columns.push(new TableColumn('ort', 'Ort'));
        this.tableDescriptor.columns.push(new TableColumn('telefon', 'Festnetz'));
        this.tableDescriptor.columns.push(new TableColumn('mobil', 'Mobil'));
        this.tableDescriptor.columns.push(new TableColumn('email', 'E-Mail'));
        this.tableDescriptor.columns.push(new TableColumn('fax', 'Fax'));
        this.tableDescriptor.columns.push(new TableColumn('editiert', 'Editiert', 'datetime'));

        this.tableDescriptor.permissionView = 9149;
        this.tableDescriptor.permissionCreate = 9142;

        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'editieren', 'edit', 9143));

        this.tableDescriptor.initialSortColumn = 'entsorger_id';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openEditDialog.bind(this);
    }

    openEditDialog(entsorger: Entsorger) {
        const dialogRef = this.dialog.open(EntsorgerDetailsDialogComponent, { data: { entsorger: entsorger } });

        dialogRef.afterClosed().subscribe(() => {
            this.tableService.reload();
        });
    }
}
